// The only destinations /login honors from ?next= (getSafeNextPath allowlist),
// shared by the email and phone sign-in surfaces and by the stale-session
// guard, which only emits ?next= for a path /login will actually return to.
export const POST_LOGIN_PATHS = ['/daily-absite-question', '/create-quiz', '/absite-diagnostic', '/quiz-history', '/user-settings'];

// Where /login sends a student with no (allowed) ?next= at all.
export const DEFAULT_POST_LOGIN_PATH = '/create-quiz';
